module.exports = require('./helpers/bundle-url').getBundleURL('aHK3C') + "logo-dark.eefe0b7f.svg";